import {
  EXPENSE_TYPE,
  EXPENSE_TYPE_LABELS,
  formatExpenseLabel,
  getSubcategoryLabel,
} from "constants/expenseConstants";
import { formatBusinessDate } from "utils/businessDate";

export const getExpenseRecordDate = (expense, expenseRecordBy = "expenseDate") => {
  if (expenseRecordBy === "createdAt") return expense?.createdAt;
  return expense?.expenseDate ?? expense?.createdAt;
};

export const formatExpenseRecordDate = (expense, expenseRecordBy = "expenseDate") => {
  const raw = getExpenseRecordDate(expense, expenseRecordBy);
  return formatBusinessDate(raw);
};

/** UI label for expenseType enum (fixed/variable). */
export const getExpenseTypeLabel = (expenseType) =>
  EXPENSE_TYPE_LABELS[expenseType] ||
  EXPENSE_TYPE_LABELS[EXPENSE_TYPE.VARIABLE];

/** Category / subcategory display (reports). Not expenseType. */
export const formatExpenseTypeLabel = (expense) => {
  const category = formatExpenseLabel(expense?.category);
  const subcategory = getSubcategoryLabel(expense?.category, expense?.subcategory);
  if (subcategory && subcategory !== "-") return `${category} / ${subcategory}`;
  return category;
};

export const getSaleNetAmount = (sale) => {
  if (sale?.saleType === "refund") return 0;
  const gross = Number(sale?.grossAmount ?? sale?.totalAmount ?? 0);
  const refund = Number(sale?.refundAmount ?? 0);
  return gross - refund;
};

export const getSaleRecordDate = (sale, salesRecordBy = "saleDate") =>
  sale?.[salesRecordBy] ?? sale?.saleDate ?? sale?.createdAt;

export const formatSaleRecordDate = (sale, salesRecordBy = "saleDate") => {
  const raw = getSaleRecordDate(sale, salesRecordBy);
  return formatBusinessDate(raw);
};

export const isRevenueSale = (sale) => !sale?.isDeleted && sale?.saleType !== "refund";

export const getMonthIndex = (dateValue) => {
  if (!dateValue) return null;
  const date = new Date(dateValue);
  return Number.isFinite(date.getTime()) ? date.getMonth() : null;
};
